import type {TypographyVariantsOptions} from '@mui/material/styles';
import {px2rem} from './px2rem';

/**
 * Standalone label style, reused in component style overrides (e.g. form
 * labels, data grid headers). Not a typography variant.
 */
export const LabelFont = {
  fontWeight: 'normal',
  fontStyle: 'normal',
  fontSize: px2rem(13),
  lineHeight: px2rem(17),
  textTransform: 'uppercase',
} as const;

export const FontsReduced: TypographyVariantsOptions = {
  h1: {
    fontWeight: 400,
    fontStyle: 'regular',
    fontSize: px2rem(23),
    lineHeight: px2rem(31),
    letterSpacing: '0.16px',
  },
  h2: {
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: px2rem(16),
    lineHeight: px2rem(22),
  },
};

export const Fonts: TypographyVariantsOptions = {
  h1: {
    fontWeight: 400,
    fontStyle: 'regular',
    fontSize: px2rem(34),
    lineHeight: px2rem(38),
    letterSpacing: '0.27px',
  },
  h2: {
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: px2rem(22),
    lineHeight: px2rem(29),
  },
  h3: {
    fontWeight: 700,
    fontStyle: 'normal',
    fontSize: px2rem(15),
    lineHeight: px2rem(24),
    textTransform: 'none',
    letterSpacing: '0.399561px',
  },
  h4: {
    fontWeight: 500,
    fontStyle: 'normal',
    fontSize: px2rem(12),
    lineHeight: px2rem(14),
  },
  /** Maps to label */
  caption: {
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontSize: px2rem(14),
    // 19 to align with body1
    lineHeight: px2rem(23),
  },
  /*** Maps to body */
  body1: {
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontSize: px2rem(16),
    lineHeight: px2rem(23),
  },
  /** Maps to input */
  body2: {
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontSize: px2rem(13),
    lineHeight: px2rem(17),
  },
  // TODO: Clean up fonts
  subtitle1: {
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontSize: px2rem(12),
    lineHeight: px2rem(17),
  },
  /** Maps to input */
  button: {
    fontWeight: '500',
    fontStyle: 'normal',
    fontSize: px2rem(12),
    lineHeight: px2rem(16),
    textTransform: 'none',
  },
} as const;
